import Api from '../api'

export default {
    getFeature(name) {
        return Api.get(`/FeatureApi/GetFeature?id=${name}`)
    }
}
